import { Padding } from './types'

export function paddingToString(padding: Padding) {
	if (typeof padding === 'string') return padding

	return `${padding[0]}px ${padding[1]}px ${padding[2]}px ${padding[3]}px`
}
